import {request} from '@/helpers/apiClient'
import {GLOBAL_API_CONFIG} from '@/utils/constants/apiConfig/globalApiConfig'
import {TARGETS_CONFIG} from '@/utils/constants/apiConfig/targetsConfig'

export const getSalesTargetsList = () => request(TARGETS_CONFIG.SALES_TARGETS)

export const getSalesTargetsColConfig = () => request(TARGETS_CONFIG.SALES_TARGETS_COL_CONFIG)

export const uploadFileService = options => request(GLOBAL_API_CONFIG.FILE_UPLOAD, options)

export const getSalesTargetCsvFile = queryParams => request(TARGETS_CONFIG.SALES_TARGETS_CSV_DOWNLOAD, '', queryParams)
